import styled from '@emotion/styled';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { spacing } from '@mui/system';

export default styled(DatePicker)<{ my?: number }>(spacing);
